// レイヤーのスーパークラス
export default class Layer {
    constructor(id, layers, paintOptions, elements) {
        this._id = id
        this._map = null;
        this._datetime = null;
        this._layers = layers;
        this._paintOptions = paintOptions;
        this._elements = elements;
        this._order = [];
        this._isDemo = false;

        this.updateOrder();
    }

    get id() { return this._id; }

    set map(map) { this._map = map; }
    get map() { return this._map; }

    set datetime(datetime) { this._datetime = datetime; }
    get datetime() { return this._datetime; }

    set layers(layers) { this._layers = layers; }
    get layers() { return this._layers; }

    set order(order) { this._order = order; }
    get order() { return this._order; }

    set paintOptions(options) {
        if (!this.map) {
            return;
        }

        this._paintOptions = options;
        Object.keys(this.layers)
            .filter(x => (this.map.getLayer(x) !== undefined))
            .map(x =>
                Object.keys(options[x])
                    .map(y =>
                        this.map.setPaintProperty(x, y, options[x][y])
                    )
            );
    }

    get paintOptions() { return this._paintOptions; }

    set elements(elements) {
        this._elements = elements;
        this.updateOrder();
    }

    get elements() { return this._elements; }

    set isDemo(isDemo) { this._isDemo = isDemo; }
    get isDemo() { return this._isDemo; }

    updateOrder() {
        const order = [];
        this._elements.forEach(x => {
            order.push(...x.layers)
        });
        this._order = order;
    }

    setPaintOption(keys, value) {
        const options = { ...this.paintOptions };
        Object.keys(options).forEach(key => {
            const option = options[key];
            keys.forEach(k => {
                if (option[k] != null) {
                    option[k] = value;
                }
            })
        });

        this.paintOptions = options;
    }

    // 継承先でオーバーライドすること。
    async add() { }
    remove() { }

    onClick(e) { }
};